import { render, staticRenderFns } from "./ContentAdministratorUser.vue?vue&type=template&id=5dbbe162&"
import script from "./ContentAdministratorUser.vue?vue&type=script&lang=js&"
export * from "./ContentAdministratorUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports